import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../helpers/firebaseAuth"; // Import your logout function

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      await logoutUser();
      navigate("/login"); // Ensure navigation after logout
    };

    handleLogout();
  }, [navigate]);

  return null; // No need to render anything
};

export default Logout;
